import { Base } from '../base-component';
import './file-download-with-image.component.scss';

export class FileDownloadWithImage extends Base {

	// containers
	container: any;
	containerDivs: any;

	// buttons
	buttons: any;
	buttonPrev: any;
	buttonNext: any;
	buttonPrevAll: any;
	buttonNextAll: any;

	// pagination
	pagination: any;

	// values
	size: any;
	currentPagination: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		this.size = 6;
		this.currentPagination = 1;

		if(this.element.closest('.file-download-with-image__main')) {

			this.container = Array.from(this.element.querySelectorAll('.file-download-with-image'));
			this.containerDivs = Array.from(this.element.querySelectorAll('.file-download-with-image__container'));
			this.pagination = this.element.querySelector('.pagination');
			this.buttonPrev = this.element.querySelector('.pagination__nav--prev');
			this.buttonNext = this.element.querySelector('.pagination__nav--next');
			this.buttonPrevAll = this.element.querySelector('.pagination__nav--prev-end');
			this.buttonNextAll = this.element.querySelector('.pagination__nav--next-end');
			this.createPagination();

		}

		

	}

	bindEvents() {

		if(this.element.querySelector('.pagination__nav--prev')) {

			this.buttonPrev.addEventListener('click', (event)=>{

				if(!this.buttonPrev.classList.contains('pagination__nav--disabled')) {
					let pagination = this.currentPagination - 1;
					this.currentPagination = pagination;
					this.paginationAction(pagination);
				}
				

			});

		}

		if(this.element.querySelector('.pagination__nav--prev-end')) {

			this.buttonPrevAll.addEventListener('click', (event)=>{

				if(!this.buttonPrev.classList.contains('pagination__nav--disabled')) {
					let pagination = 1;
					this.currentPagination = pagination;
					this.paginationAction(pagination);
				}
				

			});

		}

		if(this.element.querySelector('.pagination__nav--next')) {

			this.buttonNext.addEventListener('click', (event)=>{

				if(!this.buttonNext.classList.contains('pagination__nav--disabled')) {
					let pagination = this.currentPagination + 1;
					this.currentPagination = pagination;
					this.paginationAction(pagination);
				}

			});

		}

		if(this.element.querySelector('.pagination__nav--next-end')) {

			this.buttonNextAll.addEventListener('click', (event)=>{

				if(!this.buttonNextAll.classList.contains('pagination__nav--disabled')) {
					let buttons = Array.from(this.element.querySelectorAll('.pagination__item'));
					let pagination = buttons.length;
					this.currentPagination = pagination;
					this.paginationAction(pagination);
				}

			});

		}

	}

	paginate(event: any) {
		if (event) {
			let element: any;
			if(event.currentTarget) {
				element = event.currentTarget;
			}else{
				element = event.target;
			}
			let number = parseInt(element.getAttribute('data-number'));
			this.currentPagination = number;
			this.paginationAction(number);
		}
	}

	paginationAction(number: any) {

		let buttons = Array.from(this.element.querySelectorAll('.pagination__item'));
			
		if(number === 1) {

			this.buttonPrev.classList.add('pagination__nav--disabled');
			this.buttonPrevAll.classList.add('pagination__nav--disabled');

		}else{

			this.buttonPrev.classList.remove('pagination__nav--disabled');
			this.buttonPrevAll.classList.remove('pagination__nav--disabled');

		}

		if(number === buttons.length) {

			this.buttonNext.classList.add('pagination__nav--disabled');
			this.buttonNextAll.classList.add('pagination__nav--disabled');

		}else{

			this.buttonNext.classList.remove('pagination__nav--disabled');
			this.buttonNextAll.classList.remove('pagination__nav--disabled');

		}

		let startingPoint = 6 * number - 5;
		let endPoint = 6 * number;
		
		buttons.map((button)=>{
			let getValue = parseInt(button.getAttribute('data-number'));
			if(getValue === number) {
				button.classList.add('pagination__item--active');
			}else{
				button.classList.remove('pagination__item--active');
			}
		});

		let indexContainer = 0;
		this.containerDivs.map((item)=>{
			indexContainer++;
			item.classList.add('d-none');
			if(indexContainer >= startingPoint && indexContainer <= endPoint) {
				item.classList.remove('d-none');
			}
		});

	}

	createPagination() {

		if(this.pagination) {

			let containerItems = this.pagination.querySelector('.pagination__items');
			containerItems.innerHTML = '';

			let unorderedList = document.createElement('ul');
			unorderedList.classList.add('pagination__items');
			unorderedList.classList.add('clearfix');

			let buttonPaginateFirst = document.createElement('li');
			buttonPaginateFirst.classList.add('pagination__item');
			buttonPaginateFirst.classList.add('pagination__item--active');
			buttonPaginateFirst.setAttribute('data-number', '1');
			buttonPaginateFirst.addEventListener('click', (event)=>this.paginate(event));
			buttonPaginateFirst.innerHTML = '1';

			unorderedList.appendChild(buttonPaginateFirst);

			let count = 0;
			let pagination = 1;
			for (let index = 0; index < this.container.length; index++) {

				count++;
				if(count === 7) {

					pagination++;
					let buttonPaginateFirst = document.createElement('li');
					buttonPaginateFirst.classList.add('pagination__item');
					buttonPaginateFirst.innerHTML = pagination.toString();
					buttonPaginateFirst.setAttribute('data-number', pagination.toString());
					buttonPaginateFirst.addEventListener('click', (event)=>this.paginate(event));
					unorderedList.appendChild(buttonPaginateFirst);
					count = 1;

				}
				
			}

			containerItems.appendChild(unorderedList);

		}

	}

}


// WEBPACK FOOTER //
// ./components/file-download-with-image/file-download-with-image.component.ts